module.exports = {
      id: "visual-story-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#visual-story",
      toString: function () {
        return this.url;
      }
    }